<template>
  <div class="wrapper padding-sm">
    <pageTitleModular :orgId="orgId" :scoreId="scoreId"/>
    <p class="tips">说明：<i>*</i> 代表重点项</p>
    <div class="margin-top-sm">
      <div v-for="item in list" :key="item.id" class="score-item padding-tb-xs padding-lr-sm margin-bottom-sm"
           @click="setScoreNum(item)">
        <h3><i v-if="item.is_focus === 1">*</i>{{ item.name }}</h3>
        <div class="flex align-center justify-between">
          <span class="score-item-num">分值：{{ item.total_points }}分</span>
          <van-button type="primary" round size="small" :color="item.status===0?'#368ad1':'#ff7f21'">
            {{ item.status === 0 ? '打分' : item.score === -1 ? '无涉指标' : item.score + '分' }}
          </van-button>
        </div>
      </div>
    </div>


    <setScore :setScore="setScore" :setId="setId"
              :setItem="setItem"
              @closeScore="closeScore"/>
  </div>
</template>

<script>
import pageTitleModular from "@/components/pageTitleModular";
import {getThreeInfo} from "@/api/expert";
import setScore from "@/components/setScore";

export default {
  name: "scoreFrist",
  data() {
    return {
      orgId: '',
      scoreId: '',
      id: '',
      list: [],
      setId: 0,
      setItem: null,
      setScore: false
    }
  },
  created() {
    this.orgId = Number(this.$route.params.oid)
    this.scoreId = Number(this.$route.params.sid)
    this.id = Number(this.$route.params.id)
    this.getThreeInfo()
  },
  components: {pageTitleModular, setScore},
  methods: {
    //  关闭打分弹框
    closeScore(state) {
      this.setScore = false
      this.setId = 0
      this.setItem = null
      if (state) this.getThreeInfo()
    },
    //  点击进行打分
    setScoreNum(item) {
      this.setId = item.id
      this.setItem = item
      this.setScore = true
    },
    //  获取四级打分列表
    async getThreeInfo() {
      const res = await getThreeInfo(this.orgId, this.scoreId, this.id)
      this.list = res.data
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.wrapper {
  min-height: 100vh;

  .tips {
    font-size: 16px;

    i {
      color: #ff7f21;
    }
  }

  .score-item {
    background-color: #eef7ff;
    border-radius: 5px;

    h3 {
      font-size: 16px;
      line-height: 28px;
      position: relative;

      i {
        position: absolute;
        top: 0;
        left: -10px;
        color: #ff7f21;
      }
    }

    .score-item-num {
      color: #368ad1;
      font-size: 16px;
    }
  }
}
</style>
